module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/071-serbia-938485ac6d0fd9d3028461abac80694a.svg";